import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.autoHide = setInterval(() => {
      this.close();
    }, 10000);
  }

  disconnect() {
    clearInterval(this.autoHide);
  }

  close() {
    this.element.remove();
  }
}
